/* eslint-disable react/no-unescaped-entities */
import React from "react";
import { useTranslation } from "react-i18next";
import { AuroraBackground } from "@/components/AuroraBackground";
import { Reveal } from "@/components/Reveal";
import { Mail, MessageCircle, BookOpen } from "lucide-react";
import { Link } from "react-router-dom";

const SupportPage = () => {
  const { t } = useTranslation("site");
  const tk = (k, fb) => t(`support.${k}`, fb);
  const cards = [
    { icon: <Mail size={20} />, title: tk("card1T"), body: tk("card1B"), href: "mailto:hello@withaurora.love" },
    { icon: <MessageCircle size={20} />, title: tk("card2T"), body: tk("card2B"), href: "https://app.withaurora.love" },
    { icon: <BookOpen size={20} />, title: tk("card3T"), body: tk("card3B"), href: "/faq" },
  ];
  return (
    <>
      <section className="relative pb-12">
        <AuroraBackground variant="soft" />
        <div className="relative mx-auto max-w-7xl px-5 lg:px-8 pt-8 lg:pt-12">
          <Reveal>
            <p className="eyebrow">{tk("kicker")}</p>
            <h1 className="mt-3 font-serif text-[2.4rem] sm:text-5xl lg:text-[4rem] tracking-tight font-light leading-tight max-w-3xl">
              {tk("title1")}{" "}<em className="italic aurora-shimmer-text">{tk("title2")}</em>
            </h1>
            <p className="mt-5 max-w-2xl text-white/72 text-lg font-light">{tk("subtitle")}</p>
          </Reveal>
        </div>
      </section>

      <section className="relative py-12">
        <div className="mx-auto max-w-4xl px-5 lg:px-8 grid md:grid-cols-3 gap-5">
          {cards.map((c) => {
            const Wrap = c.href.startsWith("/") ? Link : "a";
            const wrapProps = c.href.startsWith("/") ? { to: c.href } : { href: c.href };
            return (
              <Reveal key={c.title}>
                <Wrap {...wrapProps} className="aurora-card p-7 h-full bg-[var(--aurora-coach)]/70 block">
                  <span className="size-11 rounded-2xl bg-white/8 flex items-center justify-center text-[var(--aurora-gold)] mb-4">{c.icon}</span>
                  <h3 className="font-serif text-xl">{c.title}</h3>
                  <p className="mt-2 text-white/72 font-light leading-relaxed">{c.body}</p>
                </Wrap>
              </Reveal>
            );
          })}
        </div>
      </section>
    </>
  );
};

export default SupportPage;
